<template>
  <div class="mb-5">
    <h4 class="subtitle-2 font-weight-medium">{{ title }}</h4>
    <h2 class="body-1 font-weight-medium">
      <slot>{{ formattedValue }} </slot>
    </h2>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    value: [String, Number],
    defaultValue: {
      default: "N/A",
    },
    type: {
      default: "title",
      type: String,
    },
  },

  computed: {
    formattedValue() {
      if (this.value === null || this.value === undefined || this.value === "") {
        return this.defaultValue;
      }
      switch (this.type) {
        case "title":
          return this.titleCase(this.value);
        case "date":
        case "currency":
          return this.asCurrency(this.value);

        default:
          return this.value;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.value {
  font-weight: 700;
}
</style>
